import { patchState, signalStore, withHooks, withMethods } from "@ngrx/signals";
import { setAllEntities, setEntity, withEntities } from "@ngrx/signals/entities";
import { setFulfilled, setPending, withRequestStatus } from "../extensions/request-status.feature";
import { inject } from "@angular/core";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { Observable, pipe, switchMap, tap } from "rxjs";
import { ApiQuestsService } from "../../services/api-quests.service";
import { QuestTemplateViewModel } from "@playcharge/common/models/backend/quests/backoffice/quest-template-view-model";
import { QuestTemplateEditModel } from "@playcharge/common/models/backend/quests/backoffice/quest-template-edit-model";

export type QuestTemplatesStore = InstanceType<typeof QuestTemplatesStore>;

export const QuestTemplatesStore = signalStore(
    { providedIn: "root", protectedState: false },
    withEntities<QuestTemplateViewModel>(),
    withRequestStatus(),
    withMethods((store, apiQuestsService = inject(ApiQuestsService)) => ({
        loadTemplates: rxMethod<void>(
            pipe(
                tap(() => patchState(store, setPending())),
                switchMap(() => {
                    return apiQuestsService.getTemplates().pipe(
                        tap((templates) => {
                            patchState(store, setAllEntities(templates));
                            patchState(store, setFulfilled());
                        }),
                    );
                }),
            ),
        ),
        createTemplate(model: QuestTemplateEditModel): Observable<QuestTemplateViewModel> {
            return apiQuestsService.createTemplate(model).pipe(
                tap((template) => {
                    patchState(store, setEntity(template));
                }),
            );
        },
        editTemplate(model: QuestTemplateEditModel): Observable<QuestTemplateViewModel> {
            return apiQuestsService.editTemplate(model).pipe(
                tap((template) => {
                    patchState(store, setEntity(template));
                }),
            );
        },
    })),
    withHooks((store) => ({
        onInit: () => {
            store.loadTemplates();
        },
    })),
);
